/**
 * @deprecated see EIcon enum.
 */
export enum ICON_CLASSES_DEPRECATED {
  INFO = 'icon-info',
  LOCATION = 'icon-location',
  ICON_VIEW = 'icon-view',
}
